// Fetches the map catalogue generated by the Vite plugin at build/serve time.
// Catalogue is at /maps/catalogue.json — a JSON array of PNG filenames sorted
// alphabetically by the plugin (same order displayed in the selector).

export async function getMapCatalogue() {
  try {
    const res = await fetch('/maps/catalogue.json');
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const filenames = await res.json();
    return filenames.map(filename => ({
      name: filename.replace(/\.png$/i, ''),
      url: `/maps/${encodeURIComponent(filename)}`,
    }));
  } catch (err) {
    console.warn('[mapCatalogue] Failed to fetch catalogue:', err.message);
    return [];
  }
}
